"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardUsuario = void 0;
var react_1 = __importDefault(require("react"));
var Avatar_1 = require("../Avatar/Avatar");
var Botao_1 = require("../Botao/Botao");
var Icone_1 = require("../Icone/Icone");
var Cores_1 = require("../Cores/Cores");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var estiloCardUsuario = require("./CardUsuario.module.scss");
var CardUsuario = function (_a) {
    var usuario = _a.usuario, onLogout = _a.onLogout;
    return (react_1.default.createElement("div", { className: estiloCardUsuario.principal },
        react_1.default.createElement("div", { className: estiloCardUsuario.avatar },
            react_1.default.createElement(Avatar_1.Avatar, { tamanho: "grande", src: usuario === null || usuario === void 0 ? void 0 : usuario.imagemEmpresa, icone: "storefront" })),
        react_1.default.createElement("div", { className: estiloCardUsuario.textos },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", negrito: 700, cor: Cores_1.Cores.CoresIdentidadeMU.cinzaMu }, usuario === null || usuario === void 0 ? void 0 : usuario.login),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", negrito: 500, cor: Cores_1.Cores.CoresIdentidadeMU.cinzaMu }, usuario === null || usuario === void 0 ? void 0 : usuario.empresa)),
        react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "text", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU100, tipo: "tipoIconRound", tamanho: "small", style: { cursor: "pointer" }, onClick: onLogout },
            react_1.default.createElement(Icone_1.Icone, { nome: "logout", cor: Cores_1.Cores.GradacaoPrimaria.AzulMU500 }))));
};
exports.CardUsuario = CardUsuario;
